<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="!error" id="onemap-report" class="municipality-asset-tip-report">
        <div class="reportSection">
            <div class="reportSectionHeader">
                Municipality Asset TIP Report
            </div>
        </div>
        <div class="reportSection">
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-6">
                        County:&nbsp;{{ countyName }}
                    </div>
                    <div class="col-xs-6">
                        Municipality Name:&nbsp;{{ municipalName }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSection" *ngIf="reportData">
            <div class="reportSectionHeader">
                Totals
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-2">
                        Total Number of State Bridges:&nbsp;{{ reportData.summary[0].cnt }}
                    </div>
                    <div class="col-xs-2">
                        Total Number of Local Bridges:&nbsp;{{ reportData.summary[1].cnt }}
                    </div>
                    <div class="col-xs-2">
                        Total Number of TIP Projects:&nbsp;{{ reportData.summary[2].cnt }}
                    </div>
                    <div class="col-xs-2">
                        Total Road Miles:&nbsp;{{ reportData.summary[3].cnt }}
                    </div>
                    <div class="col-xs-2">
                        Federal Aid Miles:&nbsp;{{ reportData.summary[4].cnt }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSection" *ngIf="reportData">
            <div class="reportSectionHeader">
                IRI
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-3">
                        Poor IRI (Miles):&nbsp;{{ reportData.summary[8].cnt }}
                    </div>
                    <div class="col-xs-3">
                        Fair IRI (Miles):&nbsp;{{ reportData.summary[7].cnt }}
                    </div>
                    <div class="col-xs-3">
                        Good IRI (Miles):&nbsp;{{ reportData.summary[6].cnt }}
                    </div>
                    <div class="col-xs-3">
                        Excellent IRI (Miles):&nbsp;{{ reportData.summary[5].cnt }}
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSection">
            <div class="reportSectionHeader">
                Map
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div style="width:700px;height:300px;position:relative;">
                            <mc-map #mcMap></mc-map>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSection">
            <div class="reportSectionHeader">
                Projects
            </div>
            <div class="reportSectionContent container">
                <table class="table table-condensed table-bordered" aria-label="Projects">
                    <thead>
                        <tr>
                            <th>
                                <b>Project ID</b>
                            </th>
                            <th>
                                <b>Description</b>
                            </th>
                            <th>
                                <b>Improvement Type</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="reportData">
                        <tr *ngFor="let row of reportData.projects">
                            <td>
                                <a href="?projectId={{ row.projectId }}" target="blank">{{ row.projectId }}</a>
                            </td>
                            <td>
                                {{ row.description }}
                            </td>
                            <td>
                                {{ row.improvementType }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
